// material-ui
import { alpha, styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";

// project import
import { DRAWER_WIDTH, ThemeMode } from "config";

const openedMixin = (theme) => ({
  width: DRAWER_WIDTH,
  borderRight: "1px solid",
  borderRightColor: theme.palette.divider,

  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),

  overflowX: "hidden",
  boxShadow:
    theme.palette.mode === ThemeMode.DARK
      ? `0px 1px 4px ${alpha(theme.palette.grey[900], 0.08)}`
      : "none",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),

  overflowX: "hidden",
  width: theme.spacing(7.5),
  borderRight: "none",
  boxShadow: `0px 1px 4px ${alpha(theme.palette.grey[900], 0.08)}`,
});

// ==============================|| DRAWER - MINI STYLED ||============================== //

const MiniDrawerStyled = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: DRAWER_WIDTH,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default MiniDrawerStyled;
